




















import Vue from "vue";
import { State, Action, Mutation } from "vuex-class";
import Component from "vue-class-component";
import { FacebookState } from "../../../store/facebook";
const namespace = "facebook";

@Component
export default class SelectedImages extends Vue {
  @State("facebook") facebook: FacebookState;
  @Mutation("selectAdImage", { namespace }) selectAdImage: any;
  @Mutation("unSelectAdImage", { namespace }) unSelectAdImage: any;
  @Mutation("resetImages", { namespace }) resetSelectedAdImage: any;
}
